import * as classNames from 'classnames';
import { IStateAreaEditable, IStateAreaUser } from 'common/interfaces/state';
import { Checkbox } from 'components/action';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

// Styles
const s = require('./StateArea.css');
const whiteTickIcon = require('assets/tick white.svg');

// Props
interface IStateAreaProps {
    onToggle?: (areaCode: string) => void;
    className?: string;
    area: IStateAreaEditable;
}

// Component
@observer
export class StateArea extends React.Component<IStateAreaProps, {}> {
    static get defaultProps(): IStateAreaProps {
        return {
            onToggle: null,
            className: null,
            area: null,
        };
    }

    @computed private get areaReps(): IStateAreaUser[] {
        return this.props.area && this.props.area.assignedTo
            ? this.props.area.assignedTo
            : [];
    }

    @computed private get primaryRep(): IStateAreaUser | null {
        let primaryRepIndex = -1;
        this.areaReps.some((rep, repIndex) => {
            if (rep.primary === 1) {
                primaryRepIndex = repIndex;
                return true;
            }
        });

        return primaryRepIndex !== -1 ? this.areaReps[primaryRepIndex] : null;
    }

    @computed private get secondaryRep(): IStateAreaUser | null {
        let secondaryRepIndex = -1;
        this.areaReps.some((rep, repIndex) => {
            if (rep.primary === 0) {
                secondaryRepIndex = repIndex;
                return true;
            }
        });

        return secondaryRepIndex !== -1
            ? this.areaReps[secondaryRepIndex]
            : null;
    }

    public render() {
        // Destructure
        const { area } = this.props;

        // Render
        return (
            <div className={classNames(s.stateArea, this.props.className)}>
                <div>
                    <p>
                        <strong>{area.areaCode}</strong>
                    </p>
                </div>

                <div>
                    <p>{area.providersInAreaCode || ''}</p>
                </div>

                <div>
                    <p>
                        {this.primaryRep ? (
                            <span>{this.primaryRep.name}</span>
                        ) : (
                            <em>Unassigned</em>
                        )}
                    </p>
                </div>

                <div>
                    <p>
                        {this.secondaryRep ? (
                            <span>{this.secondaryRep.name}</span>
                        ) : (
                            <em>Unassigned</em>
                        )}
                    </p>
                </div>

                <div>
                    <Checkbox
                        onChange={this.setUserToArea}
                        checked={area.checked}
                        value={area.areaCode}
                        align="right"
                    />
                </div>
            </div>
        );
    }

    private setUserToArea = (checked: boolean, value: any) => {
        if (this.props.onToggle) {
            this.props.onToggle(this.props.area.areaCode);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/state/StateArea.tsx